import styled from 'styled-components';
import { Button } from '@terrainvest/react-components';

export const StyledButton = styled(Button)`
    padding: 8px 16px !important;
`;
